const randomize = require("randomatic");

export default [
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/TextFilter"),
    props: {
      filterName: "name_contains",
      label: "Name",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/DateFilter"),
    props: {
      filterName: "startDate_gte",
      label: "Start Date (from)",
      customLabel: "Start Date (from)",
      dense: true,
      hideDetails: true,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/DateFilter"),
    props: {
      filterName: "startDate_lte",
      label: "Start Date (to)",
      customLabel: "Start Date (to)",
      dense: true,
      hideDetails: true,
    },
  },
];



// WEBPACK FOOTER //
// ./src/components/gt/open-groups/open-group-departure-filters.js